import styled from 'styled-components';

export const TableStyle = styled.div`
  .ant-table-thead > tr > th {
    background: #f0f0f0;
  }
  .ant-table {
    background: #f8f8f8;
  }
`;

export const TableSub = styled.span`
  .tableSubTotal {
    align-content: center;
    text-align: center;
    align-items: center;
  }
`;
